// Auto-generated catalog translations (de). Base content: Portuguese. Review before editing by hand.
export default {
    experiences: {
      "north-tour-cocoa-route": {
        "name": "North Tour & Cocoa Route",
        "category": "Kultur & Natur",
        "cats": ["Erlebnisse", "Kultur", "Natur"],
        "duration": "Ganztägig",
        "location": "Norden von São Tomé",
        "meetingPoint": "Abholung an der Unterkunft (Stadt São Tomé)",
        "groupSize": "Privat oder kleine Gruppe",
        "overview": "Eine Reise durch das Kakao-Erbe, historische Roças, Fischergemeinden, Strände und Landschaften im Norden von São Tomé.",
        "highlights": ["Historische Kakao-Roças", "Fischergemeinden", "Strände und Aussichtspunkte im Norden"],
        "included": ["Lokaler Guide", "Transport", "Unterstützung durch Eco Collection"],
        "notIncluded": ["Mittagessen (außer nach Vereinbarung)", "Persönliche Ausgaben"],
        "bring": ["Bequemes Schuhwerk", "Wasser", "Sonnencreme"],
      },
      "wild-south-pico-cao-grande": {
        "name": "Wild South & Pico Cão Grande",
        "category": "Natur & Inselentdeckung",
        "cats": ["Erlebnisse", "Natur"],
        "duration": "Ganztägig",
        "location": "Süden von São Tomé",
        "meetingPoint": "Abholung an der Unterkunft",
        "groupSize": "Privat oder kleine Gruppe",
        "overview": "Der wilde Süden von São Tomé: der imposante Pico Cão Grande, die Südküste, tropische Landschaften und Gemeinden, die zwischen Wald und Meer leben.",
        "highlights": ["Pico Cão Grande", "Wilde Südküste", "Lokale Gemeinden"],
        "included": ["Lokaler Guide", "Transport"],
        "notIncluded": ["Mittagessen (außer nach Vereinbarung)"],
        "bring": ["Bequemes Schuhwerk", "Wasser", "Sonnencreme"],
      },
      "ilheu-santana-by-boat": {
        "name": "Ilhéu Santana by Boat",
        "category": "Meer & Natur",
        "cats": ["Erlebnisse", "Meer", "Natur"],
        "duration": "Halbtägig",
        "location": "Ostküste, São Tomé",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Kleine Gruppe",
        "overview": "Maritimes Erlebnis entlang der Ostküste von São Tomé bis zum Ilhéu Santana, mit Vulkanlandschaften und Badestopps.",
        "highlights": ["Ilhéu Santana", "Vulkanische Küste", "Baden in kristallklarem Wasser"],
        "included": ["Boot", "Lokaler Guide"],
        "notIncluded": ["Schnorchelausrüstung (außer nach Vereinbarung)"],
        "bring": ["Badekleidung", "Handtuch", "Sonnencreme"],
      },
      "discover-principe": {
        "name": "Discover Príncipe: Roças, História & Praia Banana",
        "category": "Kultur, Natur & Geschichte",
        "cats": ["Erlebnisse", "Kultur", "Natur"],
        "duration": "± 09:00–17:00/18:00",
        "location": "Insel Príncipe",
        "meetingPoint": "Santo António",
        "groupSize": "Geführte Tour, hauptsächlich mit dem Auto",
        "overview": "Das Wesentliche von Príncipe an einem Tag: Landwirtschaft und Erbe der Roças, ikonische Strände, Gemeinden und eine lokale Initiative zur Glasverarbeitung und -wiederverwertung.",
        "highlights": ["Roça Paciência und Roça Belo Monte", "Praia Banana", "Lokale Glasrecycling-Initiative"],
        "included": ["Guide", "Fahrzeug", "Treibstoff", "Mittagessen"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Bequemes Schuhwerk", "Wasser", "Sonnencreme"],
      },
      "principe-biosphere": {
        "name": "Príncipe Biosphere: Trails, Waterfalls & Communities",
        "category": "Wandern, Natur & Gemeinde",
        "cats": ["Erlebnisse", "Natur"],
        "duration": "Ganztägig",
        "location": "Biosphärenreservat, Príncipe",
        "meetingPoint": "Santo António",
        "groupSize": "Kleine Gruppe",
        "overview": "Dichter Wald, Wasserfälle, natürliche Pools, einheimische und Heilpflanzen, lokale Gemeinden, Fischereikultur und handwerkliche Seifenherstellung.",
        "highlights": ["Wasserfall Ôquê Pipi", "Natürliche Pools", "Gemeinden und Fischereikultur"],
        "included": ["Guide", "Fahrzeug", "Treibstoff", "Mittagessen", "Nationalparkgebühr, falls zutreffend"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Wanderschuhe", "Wasser", "Mückenspray"],
      },
      "principe-by-sea": {
        "name": "Príncipe by Sea: Coast, Caves & Marine Life",
        "category": "Meer & Natur",
        "cats": ["Erlebnisse", "Meer", "Natur"],
        "duration": "± 09:00–15:00/16:00",
        "location": "Küste von Príncipe",
        "meetingPoint": "Baía de Santo António",
        "groupSize": "Kleine Gruppe",
        "overview": "Bootsausflug entlang der Küste von Príncipe: Felsformationen, Höhlen, Schwimmen, mögliches Schnorcheln, Fischergemeinden und Mittagessen am Meer, mit Rückkehr zur Baía de Santo António. Beobachtung von Schildkröten, Delfinen, Walen und Fischen je nach Jahreszeit und natürlichen Bedingungen möglich — Sichtungen nicht garantiert.",
        "highlights": ["Höhlen und Felsformationen", "Schnorcheln möglich", "Mittagessen direkt am Meer"],
        "included": ["Boot", "Lokaler Guide", "Mittagessen direkt am Meer"],
        "notIncluded": ["Schnorchelausrüstung (außer nach Vereinbarung)"],
        "bring": ["Badekleidung", "Handtuch", "Sonnencreme"],
      },
      "santiago-grand-island-tour": {
        "name": "Santiago Grand Island Tour",
        "category": "Inselentdeckung",
        "cats": ["Erlebnisse", "Kultur", "Natur"],
        "duration": "8 Std.",
        "location": "Insel Santiago",
        "meetingPoint": "Abholung am Hotel ± 08:45 Uhr",
        "groupSize": "Privat oder kleine Gruppe",
        "overview": "Nord- und Südsantiago an einem vollen Tag: die afrikanischste Insel der Kapverden, zwischen Bergen, Tälern, Geschichte und kreolischer Kultur.",
        "highlights": ["Norden und Süden der Insel", "Berglandschaften", "Kreolische Kultur"],
        "included": ["Privater Transport", "Mittagessen", "1 Flasche Wasser pro Person"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Bequemes Schuhwerk", "Sonnencreme"],
      },
      "authentic-northern-santiago": {
        "name": "Authentic Northern Santiago",
        "category": "Kultur & Lokales Leben",
        "cats": ["Erlebnisse", "Kultur"],
        "duration": "± 09:00–14:00",
        "location": "Norden von Santiago",
        "meetingPoint": "Abholung an der Unterkunft",
        "groupSize": "Kleine Gruppe",
        "overview": "Das lokale Leben im Norden von Santiago: das Vale de Principal, die Rabelados-Gemeinschaft in Espinho Branco, Bananenplantagen in Santa Cruz, der städtische Markt von Assomada und ein Fotostopp am Aussichtspunkt der Serra Malagueta.",
        "highlights": ["Rabelados-Gemeinschaft", "Markt von Assomada", "Bananenplantagen"],
        "included": ["Transport", "Mittagessen", "Wasser"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Bequemes Schuhwerk", "Kamera"],
      },
      "traditional-fishing-beach-bbq": {
        "name": "Traditional Fishing & Private Beach BBQ",
        "category": "Meer, Angeln & Gastronomie",
        "cats": ["Erlebnisse", "Meer", "Gastronomie"],
        "duration": "Halbtägig/Ganztägig",
        "location": "Tarrafal, Santiago",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Privat",
        "overview": "Traditionelles Boot, handwerkliches Fischen, Schwimmen im Meer und Zubereitung des gefangenen Fisches bei einem Strand-BBQ/Mittagessen. Möglichkeit des Transports Praia ↔ Tarrafal je nach gewählter Option.",
        "highlights": ["Handwerkliches Fischen", "Strand-BBQ", "Traditionelles Boot"],
        "included": ["Traditionelles Boot", "Mittagessen/BBQ", "Lokaler Guide"],
        "notIncluded": ["Transport Praia ↔ Tarrafal (je nach Option)"],
        "bring": ["Badekleidung", "Handtuch", "Sonnencreme"],
      },
      "tarrafal-boat-swimming": {
        "name": "Tarrafal Traditional Boat & Swimming",
        "category": "Meer",
        "cats": ["Erlebnisse", "Meer"],
        "duration": "Halbtägig",
        "location": "Tarrafal, Santiago",
        "meetingPoint": "Baía do Tarrafal",
        "groupSize": "Kleine Gruppe",
        "overview": "Traditionelle Bootsfahrt entlang der Küste von Tarrafal mit Gelegenheit zum Baden in den ruhigen Gewässern der Bucht.",
        "highlights": ["Küste von Tarrafal", "Baden im Meer", "Traditionelles Boot"],
        "included": ["Traditionelles Boot", "Lokaler Guide"],
        "notIncluded": ["Transport nach Tarrafal"],
        "bring": ["Badekleidung", "Handtuch"],
      },
      "cachupa-cooking": {
        "name": "Cape Verdean Cachupa Cooking Experience",
        "category": "Essen & Kultur",
        "cats": ["Erlebnisse", "Gastronomie", "Kultur"],
        "duration": "Halbtägig",
        "location": "Santiago",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Kleine Gruppe",
        "overview": "Praktisches Erlebnis bei der Zubereitung von Cachupa, dem kapverdischen Nationalgericht, gefolgt von einer Verkostung in authentischer Umgebung.",
        "highlights": ["Zubereitung von Cachupa", "Verkostung", "Lokale Kultur"],
        "included": ["Zutaten", "Verkostung", "Lokaler Gastgeber"],
        "notIncluded": ["Transport (außer nach Vereinbarung)"],
        "bring": ["Appetit"],
      },
      "serra-malagueta-vale-principal-trek": {
        "name": "Serra Malagueta → Vale de Principal Trek",
        "category": "Wandern & Natur",
        "cats": ["Erlebnisse", "Natur"],
        "duration": "± 2 Std. 45 Min.",
        "location": "Serra Malagueta, Santiago",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Kleine Gruppe",
        "overview": "Trekking von der Serra Malagueta zum Vale de Principal, zwischen grünen Tälern und Bergdörfern.",
        "highlights": ["Serra Malagueta", "Vale de Principal", "Bergdörfer"],
        "included": ["Transport", "Guide", "Mittagessen", "Eintrittsgebühr"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Wanderschuhe", "Wasser", "Sonnenhut", "Sonnencreme", "Sonnenbrille"],
      },
      "serra-malagueta-mato-brasil-trek": {
        "name": "Serra Malagueta → Mato Brasil Trek",
        "category": "Wandern & Natur",
        "cats": ["Erlebnisse", "Natur"],
        "duration": "± 3 Std.",
        "location": "Serra Malagueta, Santiago",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Kleine Gruppe",
        "overview": "Anspruchsvolleres Trekking von der Serra Malagueta nach Mato Brasil. Empfohlen für körperlich aktive Personen oder mit Bergerfahrung.",
        "highlights": ["Anspruchsvoller Weg", "Berglandschaften", "Endemische Natur"],
        "included": ["Transport", "Guide", "Picknick"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Wanderschuhe", "Wasser", "Sonnenhut", "Sonnencreme"],
      },
      "pico-de-antonia-challenge": {
        "name": "Pico de Antónia Challenge",
        "category": "Wandern & Herausforderung",
        "cats": ["Erlebnisse", "Natur"],
        "duration": "± 4–5 Std.",
        "location": "Pico de Antónia, Santiago",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Kleine Gruppe",
        "overview": "Trekking zum höchsten Punkt der Insel Santiago. Empfohlen für Personen mit guter Kondition und Erfahrung bei Bergwanderungen.",
        "highlights": ["Höchster Punkt von Santiago", "Berg-Herausforderung", "Panoramablick"],
        "included": ["Privater Transport", "Guide", "Picknick, je nach gewählter Konfiguration"],
        "notIncluded": ["Persönliche Ausgaben"],
        "bring": ["Wanderschuhe", "Wasser", "Sonnenhut", "Sonnencreme", "Warme Kleidung"],
      },
      "santiago-community-ecotourism": {
        "name": "Santiago Community Ecotourism",
        "category": "Gemeinde & Ökotourismus",
        "cats": ["Erlebnisse", "Kultur", "Natur"],
        "duration": "Halbtägig/Ganztägig",
        "location": "Landesinnere von Santiago",
        "meetingPoint": "Nach Bestätigung zu vereinbaren",
        "groupSize": "Kleine Gruppe",
        "overview": "Wanderungen und Kontakt mit lokalen Gemeinden, einschließlich der Möglichkeit, lokale Häuser zu besuchen, Interaktion und traditionelle Gastronomie. Endgültige Details hängen von der Konfiguration und dem Partner ab.",
        "highlights": ["Lokale Gemeinden", "Traditionelle Gastronomie", "Ökotourismus"],
        "included": ["Lokaler Guide", "Je nach Konfiguration"],
        "notIncluded": ["Je nach Konfiguration"],
        "bring": ["Bequemes Schuhwerk", "Wasser"],
      },
    },
    packages: {
      "sao-tome-discovery": {
        "name": "São Tomé Discovery",
        "duration": "3 Tage",
        "style": "Kurzaufenthalt",
        "idealFor": "Erster Besuch in São Tomé",
        "overview": "Eine perfekte Einführung in die Insel: Ankunft mit Transfer, die ikonische Kakao-Route und Freizeit vor der Abreise.",
        "highlights": ["North Tour & Cocoa Route", "Flughafentransfer inklusive", "Lokale Betreuung durch Eco Collection"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft in São Tomé + Flughafentransfer + Check-in" },
          { "day": "Tag 2", "text": "North Tour & Cocoa Route" },
          { "day": "Tag 3", "text": "Vormittag zur freien Verfügung + Abreisetransfer" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft, je nach Präferenz",
        "experiencesIncluded": ["North Tour & Cocoa Route"],
        "transfersNote": "Flughafentransfers inklusive",
        "meals": "Je nach gewählter Unterkunft",
        "included": ["Unterkunft", "Flughafentransfer", "Erlebnis North Tour & Cocoa Route", "Lokale Betreuung"],
        "notIncluded": ["Flüge", "Nicht erwähnte Mahlzeiten", "Persönliche Ausgaben"],
        "optional": ["Ilhéu Santana by Boat", "Wild South & Pico Cão Grande"],
        "important": ["Endpreis auf Anfrage, je nach Saison und Präferenzen"],
      },
      "sao-tome-explorer": {
        "name": "São Tomé Explorer",
        "duration": "5 Tage",
        "style": "Inselentdecker",
        "idealFor": "Für alle, die das Wesentliche der Insel sehen möchten",
        "overview": "Fünf Tage, um São Tomé von Nord nach Süd zu erkunden, mit Meer, Kakao und dem wilden Pico Cão Grande.",
        "highlights": ["Norden und Süden der Insel", "Ilhéu Santana", "Pico Cão Grande"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft & Begrüßung" },
          { "day": "Tag 2", "text": "North Tour & Cocoa Route" },
          { "day": "Tag 3", "text": "Wild South & Pico Cão Grande" },
          { "day": "Tag 4", "text": "Ilhéu Santana / ausgewähltes Erlebnis" },
          { "day": "Tag 5", "text": "Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["North Tour & Cocoa Route", "Wild South & Pico Cão Grande", "Ilhéu Santana by Boat"],
        "transfersNote": "Flughafentransfers inklusive",
        "meals": "Je nach gewählter Unterkunft",
        "included": ["Unterkunft", "Transfers", "Erwähnte Erlebnisse", "Lokale Betreuung"],
        "notIncluded": ["Flüge", "Nicht erwähnte Mahlzeiten"],
        "optional": ["Lokales Gastronomie-Erlebnis"],
        "important": ["Endpreis auf Anfrage"],
      },
      "sao-tome-complete": {
        "name": "São Tomé Complete",
        "duration": "8 Tage",
        "style": "Komplette Insel",
        "idealFor": "Das umfassendste Erlebnis von São Tomé",
        "overview": "Das umfassendste Erlebnis der Insel, das Norden, Süden, Meer, Kultur, Natur und Freizeit kombiniert.",
        "highlights": ["Norden, Süden und Meer", "Kultur und Gastronomie", "Freizeit für Strände"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft und Eingewöhnung" },
          { "day": "Tag 2", "text": "North Tour & Cocoa Route" },
          { "day": "Tag 3", "text": "Wild South & Pico Cão Grande" },
          { "day": "Tag 4", "text": "Ilhéu Santana by Boat" },
          { "day": "Tag 5", "text": "Natur / Wasserfall" },
          { "day": "Tag 6", "text": "Lokale Kultur & Gastronomie" },
          { "day": "Tag 7", "text": "Tag zur freien Verfügung" },
          { "day": "Tag 8", "text": "Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["North Tour & Cocoa Route", "Wild South & Pico Cão Grande", "Ilhéu Santana by Boat", "Erlebnis Natur/Wasserfall", "Lokale Kultur & Gastronomie"],
        "transfersNote": "Transfers inklusive",
        "meals": "Je nach gewählter Unterkunft",
        "included": ["Unterkunft", "Transfers", "Erwähnte Erlebnisse", "Lokale Betreuung"],
        "notIncluded": ["Flüge", "Nicht erwähnte Mahlzeiten"],
        "optional": ["Unterkunfts-Upgrades"],
        "important": ["Endpreis auf Anfrage"],
      },
      "principe-essential": {
        "name": "Príncipe Essential",
        "duration": "3 Tage",
        "style": "Kurzaufenthalt",
        "idealFor": "Ein Vorgeschmack auf Príncipe",
        "overview": "Das Wesentliche der Insel Príncipe in drei Tagen: Santo António und die ikonische Roça-Tour bis zur Praia Banana.",
        "highlights": ["Discover Príncipe Tour", "Praia Banana", "Santo António"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft + Santo António" },
          { "day": "Tag 2", "text": "Discover Príncipe: Roças, História & Praia Banana" },
          { "day": "Tag 3", "text": "Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["Discover Príncipe: Roças, História & Praia Banana"],
        "transfersNote": "Lokale Transfers inklusive",
        "meals": "Mittagessen bei der Tour inklusive",
        "included": ["Unterkunft", "Lokale Transfers", "Discover Príncipe", "Lokale Betreuung"],
        "notIncluded": ["Flüge / Verbindung São Tomé ↔ Príncipe", "Nicht erwähnte Mahlzeiten"],
        "optional": ["Príncipe by Sea"],
        "important": ["Endpreis auf Anfrage"],
      },
      "discover-principe-package": {
        "name": "Discover Príncipe",
        "duration": "5 Tage",
        "style": "Signature Island",
        "idealFor": "Drei unverkennbare Erlebnisse. Eine Inselreise.",
        "overview": "Drei unverkennbare Erlebnisse. Eine Reise über die Insel: Roças und Geschichte, Biosphäre und Wanderwege sowie Príncipe vom Meer aus gesehen.",
        "highlights": ["Roças & Praia Banana", "Biosphere & Trails", "Príncipe by Sea"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft + Unterkunft" },
          { "day": "Tag 2", "text": "Roças, História & Praia Banana" },
          { "day": "Tag 3", "text": "Biosphere, Trails, Waterfalls & Communities" },
          { "day": "Tag 4", "text": "Príncipe by Sea" },
          { "day": "Tag 5", "text": "Vormittag zur freien Verfügung + Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["Discover Príncipe", "Príncipe Biosphere", "Príncipe by Sea"],
        "transfersNote": "Lokale Transfers inklusive",
        "meals": "Mittagessen bei den Erlebnissen inklusive",
        "included": ["Unterkunft", "Lokale Transfers", "Drei unverkennbare Erlebnisse", "Lokale Betreuung"],
        "notIncluded": ["Flüge / Verbindung São Tomé ↔ Príncipe"],
        "optional": ["Zusätzlicher Strandtag"],
        "important": ["Endpreis auf Anfrage"],
      },
      "stp-signature": {
        "name": "São Tomé & Príncipe Signature",
        "duration": "8 Tage",
        "style": "Zwei Inseln",
        "idealFor": "Beide Inseln auf einer einzigen Reise",
        "overview": "Das Beste beider Inseln: Kakao und der wilde Süden in São Tomé sowie das unverkennbare Trio von Príncipe.",
        "highlights": ["Zwei Inseln", "Kakao + Biosphäre + Meer", "Durchgehende lokale Betreuung"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft in São Tomé" },
          { "day": "Tag 2", "text": "Norden & Kakao" },
          { "day": "Tag 3", "text": "Wild South" },
          { "day": "Tag 4", "text": "Transfer / Flug nach Príncipe" },
          { "day": "Tag 5", "text": "Roças & Praia Banana" },
          { "day": "Tag 6", "text": "Biosphere & Trails" },
          { "day": "Tag 7", "text": "Príncipe by Sea / Freizeit" },
          { "day": "Tag 8", "text": "Abreise" },
        ],
        "accommodationNote": "Lokale Unterkünfte auf beiden Inseln",
        "experiencesIncluded": ["North Tour & Cocoa Route", "Wild South & Pico Cão Grande", "Discover Príncipe", "Príncipe Biosphere", "Príncipe by Sea"],
        "transfersNote": "Transfers und Verbindung zwischen den Inseln, koordiniert von Eco Collection",
        "meals": "Gemäß Programm",
        "included": ["Unterkünfte", "Transfers", "Erwähnte Erlebnisse", "Lokale Betreuung"],
        "notIncluded": ["Internationale Flüge"],
        "optional": ["Unterkunfts-Upgrades"],
        "important": ["Endpreis auf Anfrage"],
      },
      "stp-grand-journey": {
        "name": "STP Grand Journey",
        "duration": "10 Tage",
        "style": "Premium & Anpassbar",
        "idealFor": "Maßgeschneiderte Premium-Reise",
        "overview": "Das Premium-Produkt von Eco Collection: Unterkunft, Transfers, vielfältige Erlebnisse, Freizeit, lokale Betreuung und optionale Upgrades — vollständig anpassbar.",
        "highlights": ["Vollständig anpassbar", "Premium", "Optionale Upgrades"],
        "itinerary": [
          { "day": "Tag 1–4", "text": "São Tomé: Norden, Süden, Meer und Kultur" },
          { "day": "Tag 5", "text": "Verbindung nach Príncipe" },
          { "day": "Tag 6–9", "text": "Príncipe: Roças, Biosphäre, Meer und Freizeit" },
          { "day": "Tag 10", "text": "Abreise" },
        ],
        "accommodationNote": "Mit Ihnen ausgewählte Unterkünfte",
        "experiencesIncluded": ["Maßgeschneidertes Programm"],
        "transfersNote": "Alle Transfers koordiniert",
        "meals": "Gemäß Programm",
        "included": ["Unterkünfte", "Transfers", "Kombinierte Erlebnisse", "Engagierte lokale Betreuung"],
        "notIncluded": ["Internationale Flüge"],
        "optional": ["Upgrades", "Zusätzliche Erlebnisse", "Zusätzliche Nächte"],
        "important": ["Persönliches Angebot auf Anfrage"],
      },
      "santiago-essential": {
        "name": "Santiago Essential",
        "duration": "3 Tage",
        "style": "Kurzaufenthalt",
        "idealFor": "Strand + Kultur + Einführung in die Insel",
        "overview": "Strand, Kultur und eine Einführung in die Insel Santiago in drei Tagen.",
        "highlights": ["Cidade Velha", "Strand", "Kreolische Kultur"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft / Transfer" },
          { "day": "Tag 2", "text": "Cidade Velha / Südregion + lokales Erlebnis" },
          { "day": "Tag 3", "text": "Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["Lokales Erlebnis nach Wahl"],
        "transfersNote": "Ankunftstransfer inklusive",
        "meals": "Je nach Unterkunft",
        "included": ["Unterkunft", "Ankunftstransfer", "Lokales Erlebnis", "Lokale Betreuung"],
        "notIncluded": ["Flüge"],
        "optional": ["Cachupa Cooking Experience"],
        "important": ["Endpreis auf Anfrage"],
      },
      "santiago-explorer": {
        "name": "Santiago Explorer",
        "duration": "5 Tage",
        "style": "Inselentdecker",
        "idealFor": "Santiago komplett: Strand, Landesinneres und Norden",
        "overview": "Strand, Cidade Velha, das Landesinnere, der Norden von Santiago, Serra Malagueta / Tarrafal und lokale Kultur in fünf Tagen.",
        "highlights": ["Cidade Velha", "Landesinneres + Norden", "Serra Malagueta / Tarrafal"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft" },
          { "day": "Tag 2", "text": "Cidade Velha & Südregion" },
          { "day": "Tag 3", "text": "Landesinneres" },
          { "day": "Tag 4", "text": "Norden von Santiago / Serra Malagueta / Tarrafal" },
          { "day": "Tag 5", "text": "Lokale Kultur + Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["Santiago Grand Island Tour", "Authentic Northern Santiago"],
        "transfersNote": "Transfers inklusive",
        "meals": "Gemäß Programm",
        "included": ["Unterkunft", "Transfers", "Erwähnte Erlebnisse", "Lokale Betreuung"],
        "notIncluded": ["Flüge"],
        "optional": ["Traditional Fishing & Beach BBQ"],
        "important": ["Endpreis auf Anfrage"],
      },
      "santiago-active-local": {
        "name": "Santiago Active & Local",
        "duration": "7 Tage",
        "style": "Aktiv & Lokal",
        "idealFor": "Aktive Reisende, die die Insel erleben möchten",
        "overview": "Eine aktive und lokale Woche in Santiago: die komplette Insel, Trekking, Meer, traditioneller Fischfang und Gastronomie.",
        "highlights": ["Grand Island Tour", "Trek Serra Malagueta", "Fischfang & BBQ + Cachupa"],
        "itinerary": [
          { "day": "Tag 1", "text": "Ankunft" },
          { "day": "Tag 2", "text": "Santiago Grand Island Tour" },
          { "day": "Tag 3", "text": "Serra Malagueta → Vale Principal Trek" },
          { "day": "Tag 4", "text": "Freizeit / Strand" },
          { "day": "Tag 5", "text": "Traditional Fishing & Beach BBQ" },
          { "day": "Tag 6", "text": "Cachupa Cooking & Lokale Kultur" },
          { "day": "Tag 7", "text": "Abreise" },
        ],
        "accommodationNote": "Ausgewählte lokale Unterkunft",
        "experiencesIncluded": ["Santiago Grand Island Tour", "Serra Malagueta → Vale de Principal Trek", "Traditional Fishing & Private Beach BBQ", "Cachupa Cooking Experience"],
        "transfersNote": "Transfers inklusive",
        "meals": "Gemäß Programm (Mittagessen bei den Erlebnissen)",
        "included": ["Unterkunft", "Transfers", "Erwähnte Erlebnisse", "Lokale Betreuung"],
        "notIncluded": ["Flüge"],
        "optional": ["Pico de Antónia Challenge"],
        "important": ["Endpreis auf Anfrage"],
      },
    },
    transfers: {
      "praia-tarrafal": {
        "capacities": ["1–3 Passagiere", "4–14 Passagiere"],
        "name": "Praia Airport / Praia → Tarrafal",
        "distance": "74 km",
        "time": "± 1 Std. 30 Min.",
        "vehicle": "Privater Transfer",
        "note": "Endpreis auf Anfrage, abhängig von Fahrzeug und Anzahl der Passagiere.",
        "points": [
          { "name": "Praia", "lat": 14.917, "lng": -23.509 },
          { "name": "Tarrafal", "lat": 15.276, "lng": -23.752 },
        ],
      },
    },
    destinations: {
      "sao-tome-principe": {
        "positioning": "Kakao, tropischer Regenwald und unberührte Strände.",
        "categories": ["Kultur & Natur", "Meer", "Wandern", "Unterkünfte", "Transfers", "Komplettpakete"],
        "subs": {
          "sao-tome": { "tagline": "Wo der Wald auf den Ozean trifft.", "cta": "São Tomé erkunden", "desc": "Die Hauptinsel des Archipels: tropische Wälder des Parque Natural do Obô, jahrhundertealte Kakao-Roças, einsame Strände und eine lebendige kreolische Kultur. Jedes Erlebnis wird von lokalen Profis aus unserem Netzwerk geführt." , "tags": "Natur · Kultur · Kakao"},
          "principe": { "tagline": "Natur in ihrer reinsten Form.", "cta": "Príncipe entdecken", "desc": "UNESCO-Weltbiosphärenreservat: unberührter Primärwald, versteckte Wasserfälle, historische Roças und einige der schönsten Strände Afrikas, wie die ikonische Praia Banana." , "tags": "Biosphäre · Strände · Roças"},
        },
      },
      "cabo-verde": {
        "positioning": "Wo die Berge auf das Meer treffen.",
        "categories": ["Wandern", "Kultur", "Meer", "Gastronomie", "Unterkünfte", "Transfers", "Komplettpakete"],
        "subs": {
          "santiago": { "tagline": "Wo die Berge auf das Meer treffen.", "cta": "Santiago erkunden", "desc": "Auf der Insel Santiago, wo die Berge auf das Meer treffen: Vulkanpfade in der Serra Malagueta, das UNESCO-Weltkulturerbe Cidade Velha, handwerklicher Fischfang und die kreolische Seele der kapverdischen Musik." , "tags": "Berge · Ozean · Kultur"},
        },
      },
      "ghana": {
        "cta": "Ghana entdecken",
        "positioning": "Kultur, Erbe und Gemeindetourismus.",
        "categories": ["Kultur & Erbe", "Lokale Erlebnisse", "Natur", "Gemeindetourismus", "Unterkünfte", "Transfers", "Komplettpakete"],
        "subs": {
        },
      },
      "kenya": {
        "cta": "Kenia planen",
        "positioning": "Safari, Tierwelt und Küste.",
        "categories": ["Safari", "Tierwelt", "Kultur", "Natur", "Küste", "Gemeindeerlebnisse", "Unterkünfte", "Transfers", "Komplettpakete"],
        "subs": {
        },
      },
      "tanzania": {
        "cta": "Tansania planen",
        "positioning": "Von außergewöhnlichen Landschaften über lokale Gemeinden bis hin zum Indischen Ozean.",
        "categories": ["Safari", "Tierwelt", "Natur", "Kultur", "Lokale Gemeinden", "Sansibar / Küste", "Unterkünfte", "Transfers", "Komplettpakete"],
        "subs": {
        },
      },
      "mauritius": {
        "cta": "Mauritius entdecken",
        "positioning": "Entdecken Sie Mauritius durch die Menschen, die es am besten kennen.",
        "categories": ["Inselerlebnisse", "Strände", "Natur", "Kultur", "Gastronomie", "Bootserlebnisse", "Unterkünfte", "Transfers", "Komplettpakete"],
        "subs": {
        },
      },
      "maldives": {
        "cta": "Malediven entdecken",
        "positioning": "Erleben Sie die Malediven jenseits des Postkartenmotivs.",
        "categories": ["Inselaufenthalte", "Lokale Inseln", "Resorts", "Meereserlebnisse", "Tauchen / Schnorcheln", "Bootserlebnisse", "Transfers", "Komplettpakete"],
        "subs": {
        },
      },
    },
};
